<template>
  <div style="height: 100%;" class="articleContent-container">
    <!-- 移除侧边栏，在iframe中不显示任何媒体弹框 -->
    <template v-if="content">
      <div class="articleLog">
          <div class="breadcrumbBox" >  
            <div class="breadcrumb-content">
              <span style="display: inline-block;transform: rotate(180deg) !important;" class="return-btn" @click="handleBack()">
            <i  style="cursor: pointer;font-size: 14px;" class="iconfont icon-right"></i>
          </span> 

            
              <span class="articleTitle">{{ title || articleTitle }}</span>
            </div>
          </div>
          <div class="articleContent">
            <div
              style="display: flex; align-items: center; justify-content: center; margin-bottom: 16px;padding:0px 0px"
              v-html="iframeContent"
              v-if="iframeContent"
              @click="handleIframeMediaClick"
            ></div>
            <v-md-preview
              :text="content"
              ref="preview"
              class="mdview"
              @click="handleMediaClick"
            ></v-md-preview>      
              <FeedbackModal
      
      :articleId="id"
      :articleTitle="articleTitle || title"
    
     
    />
          </div>
  

          <!-- <div class="sharebox">
            分享本文：<share :config="config" style="display: inline"></share>
          </div> -->
        </div>
       
    </template>
    <div v-else >
      <div v-if="loadding"  class="articleContent-nodata">
        <a-spin size="large" />
       <div style="padding: 32px;padding-top: 16px;" v-if="outlinkid"> Will automatically redirect to the corresponding document...</div>
      </div>
      <NoData v-else />
    </div>
  </div>
</template>
<script></script>
<script>
import NoData from "@/views/noData.vue";
import { articles, getJSON } from "@/utils/query.js";
import { getNowDate } from "@/utils/tool.js";
import FeedbackModal from "@/views/FeedbackModal.vue";
const shareText = ""
export default {
  components: { NoData,FeedbackModal },
  props: {
    outlinkid: {
      default: false,
    },
    id: {},
    title: {},
    isShow: {
      default: true,
    },
  },
  data() {
    return {
      targetOffset: window.innerHeight / 4,
      loadding: false,
      h3list: [],
      imglist: [],
      articleTime: "",
      content: "",
      showArticle: false,
      isshow: "",
      config: {
        // url: "", // 网址，默认使用 window.location.href
        source: "", // 来源（QQ空间会用到）, 默认读取head标签：<meta name="site" content="http://overtrue" />
        title: "", // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
        description: "", // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
        image: "", // 图片, 默认取网页中第一个img标签
        sites: ["weibo", "wechat", "qq", "qzone"], // 启用的站点
        // disabled: ["google", "facebook", "twitter"], // 禁用的站点
        wechatQrcodeTitle: "微信扫一扫：分享", // 微信二维码提示文字
        wechatQrcodeHelper:
          "<p>微信里点“发现”，扫一下</p><p>二维码便可将本文分享至朋友圈。</p>",
      },
      iframeContent: "",
      // 悬浮框相关数据
      showMediaModal: false,
      currentMedia: "",
      mediaType: "",
      mediaTitle: "",
      // 移除动态 margin-top 相关数据，使用 flex 布局
    };
  },
    computed: {
    isIsp() {
      return sessionStorage.getItem("isIsp") === "true";
    },

    homeHref() {
      return this.isIsp ? "/help/#/isp" : "/help/";
    },
  },
  watch: {
    id(value) {
      this.content = "";
      this.getArticles(value);
    },
    content() {
      document.documentElement.scrollTop = 0;
      this.onAddUrl();
      // 内容更新后重新绑定事件
      this.$nextTick(() => {
        this.addGlobalClickListeners();
      });
    },
  },
  mounted() {
    this.getArticles(this.id);
    // 添加键盘事件监听
    document.addEventListener('keydown', this.handleKeydown);
    // 添加父页面消息监听
    window.addEventListener('message', this.handleParentMessage);
    // 添加全局点击事件监听
    this.addGlobalClickListeners();
    // 在iframe中禁用viewer功能
    this.disableViewerInIframe();
  },
  

  
  beforeDestroy() {
    // 移除键盘事件监听
    document.removeEventListener('keydown', this.handleKeydown);
    // 移除父页面消息监听
    window.removeEventListener('message', this.handleParentMessage);
    // 移除全局点击事件监听
    document.removeEventListener('click', this.handleGlobalClick);
    // 移除preview点击事件监听
    if (this.$refs.preview) {
      this.$refs.preview.$el.removeEventListener('click', this.handlePreviewClick);
    }
    // 清理viewer检查定时器
    if (this.viewerCheckInterval) {
      clearInterval(this.viewerCheckInterval);
    }
    // 恢复 body 样式
    this.restoreBodyBackground();
  },
  methods: {
    
    
    handleBack(){
      this.$emit('handleBack');
    },
    onAddUrl() {
      this.$nextTick(function() {
        let _aList = this.$refs.preview.$el.querySelectorAll(
          "h1,h2,h3,h4,h5,h6"
        );
        let list = [];
        for (let i = 0; i < _aList.length; i++) {
          let _a = _aList[i];
          console.log(_a);
          let id = _a.getAttribute("data-v-md-line");
          if (!id) continue; // 把不属于导航中的a标签去掉，否则会报错
          _a.id = id; //锚点
          _a.xx = id; //锚点
          list.push(_a);
        }
        this.h3list = list;
        console.log("%O", this.$refs.preview.$el);
      });
    },
    async getArticles(id) {
      if (!id) return;
      this.loadding = true;
      let res = await articles(id);
      let { code, data } = res;
      if (code == "200" && data) {
        let { content, title, updateTime } = res.data;
        this.articleTitle = title;
        this.$emit("setarticleTitle", title);
        this.articleTime = getNowDate(updateTime);
        this.getContent(content);
      } else {
        this.loadding = false;
      }
      // 发送诸葛io埋点数据
      // 查一个文章 全局计数count 加一
      this.GLOBAL.count++;
      this.sentzhugePoint(id);
    },
    async getContent(contentUrl) {
      this.iframeContent = "";
      let json = await getJSON(contentUrl);
      this.content = json ? json : "";
      // 提取第一个 <iframe ...>...</iframe> 字符串
      const iframeMatch = this.content.match(/<iframe[\s\S]*?<\/iframe>/i);
      let iframeContent = iframeMatch ? iframeMatch[0] : "";

     if(iframeContent){
      iframeContent = iframeContent.replace('height="315"', 'height="200"');
     }
      this.iframeContent = iframeContent;
      // 移除所有 <iframe ...></iframe> 标签（包括YouTube等嵌入视频）
      this.content = this.content.replace(/<iframe[\s\S]*?<\/iframe>/gi, "");
      this.loadding = false;
      
      // 在下一个事件循环中修复空的 data-tooltip-title 属性
      this.$nextTick(() => {
        this.fixEmptyTooltipTitlesInIframe();
      });
      
      // 内容更新后重新禁用viewer
      this.$nextTick(() => {
        this.disableViewerInIframe();
      });
    },
    sentzhugePoint(articleid) {
      let articleTitle = this.title || this.articleTitle;
      this.zhugePoint("macc-help-文档中心-文章统计", {
        userid: this.GLOBAL.userid, //用户id
        articleid, //文章id
        articleTitle, //文章标题
      });
      console.log("macc-help-文档中心-文章统计", articleTitle);
    },
    handleAnchor(anchor) {
      console.log(anchor);
      const { preview } = this.$refs;
      const heading = anchor;

      // const heading = preview.$el.querySelector(`[data-v-md-line="${lineIndex}"]`);

      if (heading) {
        // 注意：如果你使用的是编辑组件的预览模式,则这里的方法名改为 previewScrollToTarget
        preview.scrollToTarget({
          target: heading,
          scrollContainer: window,
          top: 60,
        });
      }
    },
    
    // 处理媒体点击事件 - 发送到父页面
    handleMediaClick(event) {
      console.log('handleMediaClick 被调用', event.target);
      const target = event.target;
      
      // 在iframe环境中不显示alert，直接处理
      if (window.parent && window.parent !== window) {
        console.log('在iframe中，直接处理点击事件');
      } else {
        alert("handleMediaClick 被调用");
      }
      
      // 检查是否点击的是图片
      if (target.tagName === 'IMG') {
        console.log('点击了图片:', target.src);
        this.sendMediaToParent('image', target.src, target.alt || '图片');
      }
      // 检查是否点击的是视频
      else if (target.tagName === 'VIDEO') {
        console.log('点击了视频:', target.src);
        this.sendMediaToParent('video', target.src, target.title || '视频');
      } else {
        console.log('点击了其他元素:', target.tagName, target);
      }
    },
    
    // 发送媒体信息到父页面
    sendMediaToParent(type, src, title) {
      console.log('sendMediaToParent 被调用:', { type, src, title });
      console.log('window.parent:', window.parent);
      console.log('window.parent !== window:', window.parent !== window);
      
      try {
        // 检查是否在iframe中
        if (window.parent && window.parent !== window) {
          console.log("在iframe中，发送消息到父页面");
          
          // 获取所有媒体列表和当前索引
          const mediaList = this.getAllMediaList();
          const currentIndex = this.getCurrentMediaIndex(src, mediaList);
          
          const message = {
            type: 'showMediaModal',
            mediaType: type,
            mediaSrc: src,
            mediaTitle: title,
            mediaList: mediaList,
            currentIndex: currentIndex
          };
          
          console.log('发送的消息:', message);
          window.parent.postMessage(message, '*');
          console.log('消息已发送到父页面，不显示本地弹框');
          // 在iframe中不显示本地弹框，直接返回
          return;
        } else {
          console.log("不在iframe中，使用本地弹框");
          // 如果不在iframe中，使用本地弹框
          this.showLocalModal(type, src, title);
        }
      } catch (error) {
        console.error('发送消息到父页面失败:', error);
        // 只有在发送失败时才降级到本地弹框
        console.log('发送失败，使用本地弹框作为降级方案');
        this.showLocalModal(type, src, title);
      }
    },
    
    // 本地弹框（降级方案）- 在iframe中不使用
    showLocalModal(type, src, title) {
      // 在iframe环境中不使用本地弹框
      if (window.parent && window.parent !== window) {
        console.log('在iframe环境中，不使用本地弹框');
        return;
      }
      
      // 只在独立环境中使用本地弹框
      this.currentMedia = src;
      this.mediaType = type;
      this.mediaTitle = title;
      this.showMediaModal = true;
    },
    
    // 显示图片悬浮框（保留用于降级）
    showImageModal(src, title) {
      this.showLocalModal('image', src, title);
    },
    
    // 显示视频悬浮框（保留用于降级）
    showVideoModal(src, title) {
      this.showLocalModal('video', src, title);
    },
    
    // 关闭悬浮框 - 在iframe中不使用
    closeMediaModal() {
      // 在iframe环境中不使用本地弹框
      if (window.parent && window.parent !== window) {
        console.log('在iframe环境中，不使用本地弹框');
        return;
      }
      
      // 只在独立环境中使用本地弹框
      this.showMediaModal = false;
      this.currentMedia = '';
      this.mediaType = '';
      this.mediaTitle = '';
    },
    
    // 在iframe中禁用viewer功能
    disableViewerInIframe() {
      // 检查是否在iframe中
      if (window.parent && window.parent !== window) {
        console.log('在iframe中，禁用viewer功能');
        
        // 移除viewer的点击事件
        this.$nextTick(() => {
          // 禁用viewer的图片点击事件
          const images = document.querySelectorAll('.articleContent img');
          images.forEach(img => {
            // 移除viewer相关的事件监听器
            img.removeEventListener('click', null);
            // 确保我们的点击事件能正常工作
            img.style.pointerEvents = 'auto';
          });
          
          // 隐藏任何已存在的viewer弹框
          const viewerElements = document.querySelectorAll('[class*="viewer-"]');
          viewerElements.forEach(el => {
            el.style.display = 'none';
            el.style.visibility = 'hidden';
            el.style.opacity = '0';
            el.style.pointerEvents = 'none';
          });
        });
        
        // 定期检查并禁用viewer弹框
        this.viewerCheckInterval = setInterval(() => {
          const viewerElements = document.querySelectorAll('[class*="viewer-"]');
          viewerElements.forEach(el => {
            el.style.display = 'none';
            el.style.visibility = 'hidden';
            el.style.opacity = '0';
            el.style.pointerEvents = 'none';
          });
        }, 100);
      }
    },
    
    // 处理键盘事件
    handleKeydown(event) {
      if (event.key === 'Escape' && this.showMediaModal) {
        this.closeMediaModal();
      }
    },
    
    // 处理来自父页面的消息
    handleParentMessage(event) {
      // 验证消息来源（可选）
      // if (event.origin !== 'https://your-parent-domain.com') return;
      
      const { type, action } = event.data;
      
      switch (type) {
        case 'mediaModalResponse':
          // 处理父页面对媒体弹框的响应
          if (action === 'closed') {
            console.log('父页面已关闭媒体弹框');
          }
          break;
        case 'requestMediaInfo':
          // 响应父页面的媒体信息请求
          this.sendCurrentMediaInfo();
          break;
        default:
          break;
      }
    },
    
    // 获取文章内容中的媒体列表
    getAllMediaList() {
      const mediaList = [];
      
      // 方法1：从v-md-preview组件中获取媒体
      if (this.$refs.preview) {
        const previewElement = this.$refs.preview.$el;
        const previewImages = previewElement.querySelectorAll('img');
        previewImages.forEach((img, index) => {
          if (img.src && img.src.trim() !== '' && !this.isExcludedImage(img)) {
            mediaList.push({
              type: 'image',
              url: img.src,
              title: img.alt || `图片 ${index + 1}`,
              index: index
            });
          }
        });
        
        const previewVideos = previewElement.querySelectorAll('video');
        previewVideos.forEach((video, index) => {
          if (video.src && video.src.trim() !== '') {
            mediaList.push({
              type: 'video',
              url: video.src,
              title: video.title || `视频 ${index + 1}`,
              index: previewImages.length + index
            });
          }
        });
      }
      
      // 方法2：从文章内容区域获取媒体（备用方案）
      if (mediaList.length === 0) {
        const articleContent = document.querySelector('.articleContent');
        if (articleContent) {
          const images = articleContent.querySelectorAll('img');
          images.forEach((img, index) => {
            if (img.src && img.src.trim() !== '' && !this.isExcludedImage(img)) {
              mediaList.push({
                type: 'image',
                url: img.src,
                title: img.alt || `图片 ${index + 1}`,
                index: index
              });
            }
          });
          
          const videos = articleContent.querySelectorAll('video');
          videos.forEach((video, index) => {
            if (video.src && video.src.trim() !== '') {
              mediaList.push({
                type: 'video',
                url: video.src,
                title: video.title || `视频 ${index + 1}`,
                index: images.length + index
              });
            }
          });
        }
      }
      
      // 方法3：从iframe内容中获取媒体
      if (this.iframeContent) {
        // 解析iframe内容中的图片
        const iframeImages = this.extractImagesFromIframeContent();
        iframeImages.forEach((img, index) => {
          mediaList.push({
            type: 'image',
            url: img.src,
            title: img.alt || `iframe图片 ${index + 1}`,
            index: mediaList.length + index
          });
        });
      }
      
      console.log('获取到的文章媒体列表:', mediaList);
      return mediaList;
    },
    
    // 检查是否为需要排除的图片（如logo、图标等）
    isExcludedImage(img) {
      const excludedClasses = ['logo', 'icon', 'avatar', 'thumbnail'];
      const excludedSrcs = ['logo', 'icon', 'avatar', 'favicon'];
      
      // 检查class
      for (const className of excludedClasses) {
        if (img.className && img.className.includes(className)) {
          return true;
        }
      }
      
      // 检查src
      for (const srcKeyword of excludedSrcs) {
        if (img.src && img.src.toLowerCase().includes(srcKeyword)) {
          return true;
        }
      }
      
      return false;
    },
    
    // 从iframe内容中提取图片
    extractImagesFromIframeContent() {
      const images = [];
      
      if (this.iframeContent) {
        // 使用正则表达式提取img标签
        const imgRegex = /<img[^>]+src=["']([^"']+)["'][^>]*>/gi;
        let match;
        
        while ((match = imgRegex.exec(this.iframeContent)) !== null) {
          const imgTag = match[0];
          const src = match[1];
          
          // 提取alt属性
          const altMatch = imgTag.match(/alt=["']([^"']*)["']/i);
          const alt = altMatch ? altMatch[1] : '';
          
          images.push({
            src: src,
            alt: alt
          });
        }
      }
      
      return images;
    },
    
    // 获取当前媒体在列表中的索引
    getCurrentMediaIndex(src, mediaList) {
      const index = mediaList.findIndex(item => item.url === src);
      console.log('当前媒体索引:', index, '媒体URL:', src);
      return index >= 0 ? index : 0;
    },
    
    // 发送当前媒体信息到父页面
    sendCurrentMediaInfo() {
      if (this.showMediaModal) {
        const mediaList = this.getAllMediaList();
        const currentIndex = this.getCurrentMediaIndex(this.currentMedia, mediaList);
        
        window.parent.postMessage({
          type: 'currentMediaInfo',
          mediaType: this.mediaType,
          mediaSrc: this.currentMedia,
          mediaTitle: this.mediaTitle,
          mediaList: mediaList,
          currentIndex: currentIndex
        }, '*');
      }
    },
    
    // 添加全局点击事件监听
    addGlobalClickListeners() {
      // 使用 nextTick 确保 DOM 已更新
      this.$nextTick(() => {
        // 监听整个文档的点击事件
        document.addEventListener('click', this.handleGlobalClick);
        
        // 特别监听 v-md-preview 组件内的点击
        if (this.$refs.preview) {
          this.$refs.preview.$el.addEventListener('click', this.handlePreviewClick);
        }
      });
    },
    
    // 全局点击事件处理
    handleGlobalClick(event) {
      const target = event.target;
      
      // 检查是否点击的是图片
      if (target.tagName === 'IMG') {
        console.log('全局点击检测到图片:', target.src);
        // 在iframe环境中不显示alert，直接发送消息
        if (window.parent && window.parent !== window) {
          console.log('在iframe中，直接发送消息到父页面');
        } else {
          alert('全局点击检测到图片: ' + target.src);
        }
        this.sendMediaToParent('image', target.src, target.alt || '图片');
      }
      // 检查是否点击的是视频
      else if (target.tagName === 'VIDEO') {
        console.log('全局点击检测到视频:', target.src);
        // 在iframe环境中不显示alert，直接发送消息
        if (window.parent && window.parent !== window) {
          console.log('在iframe中，直接发送消息到父页面');
        } else {
          alert('全局点击检测到视频: ' + target.src);
        }
        this.sendMediaToParent('video', target.src, target.title || '视频');
      }
    },
    
    // v-md-preview 组件内的点击事件处理
    handlePreviewClick(event) {
      console.log('v-md-preview 点击事件:', event.target);
      const target = event.target;
      
      // 检查是否点击的是图片
      if (target.tagName === 'IMG') {
        console.log('preview中点击了图片:', target.src);
        // 在iframe环境中不显示alert，直接发送消息
        if (window.parent && window.parent !== window) {
          console.log('在iframe中，直接发送消息到父页面');
        } else {
          alert('preview中点击了图片: ' + target.src);
        }
        this.sendMediaToParent('image', target.src, target.alt || '图片');
      }
      // 检查是否点击的是视频
      else if (target.tagName === 'VIDEO') {
        console.log('preview中点击了视频:', target.src);
        // 在iframe环境中不显示alert，直接发送消息
        if (window.parent && window.parent !== window) {
          console.log('在iframe中，直接发送消息到父页面');
        } else {
          alert('preview中点击了视频: ' + target.src);
        }
        this.sendMediaToParent('video', target.src, target.title || '视频');
      }
    },
    
    // 处理 iframe 内容中的媒体点击事件
    handleIframeMediaClick(event) {
      console.log('handleIframeMediaClick 被调用', event.target);
      const target = event.target;
      
      // 在iframe环境中不显示alert，直接处理
      if (window.parent && window.parent !== window) {
        console.log('在iframe中，直接处理iframe内容点击事件');
      } else {
        alert('handleIframeMediaClick 被调用');
      }
      
      // 处理 data-tooltip-title 属性为空的情况
      this.fixEmptyTooltipTitles(target);
      
      // 检查是否点击的是图片
      if (target.tagName === 'IMG') {
        console.log('iframe中点击了图片:', target.src);
        this.sendMediaToParent('image', target.src, target.alt || '图片');
      }
      // 检查是否点击的是视频
      else if (target.tagName === 'VIDEO') {
        console.log('iframe中点击了视频:', target.src);
        this.sendMediaToParent('video', target.src, target.title || '视频');
      } else {
        console.log('iframe中点击了其他元素:', target.tagName, target);
      }
    },
    
    // 修复空的 data-tooltip-title 属性
    fixEmptyTooltipTitles(element) {
      // 查找所有具有 data-tooltip-title 属性的子元素
      const elementsWithTooltip = element.querySelectorAll('[data-tooltip-title]');
      
      elementsWithTooltip.forEach(el => {
        const tooltipTitle = el.getAttribute('data-tooltip-title');
        
        // 如果 data-tooltip-title 为空或只有空白字符
        if (!tooltipTitle || tooltipTitle.trim() === '') {
          // 尝试从其他属性获取标题
          const alt = el.getAttribute('alt');
          const title = el.getAttribute('title');
          const ariaLabel = el.getAttribute('aria-label');
          
          // 设置一个默认的 tooltip 标题
          const newTitle = alt || title || ariaLabel || '点击查看详情';
          el.setAttribute('data-tooltip-title', newTitle);
          
          console.log('修复空的 data-tooltip-title:', {
            element: el,
            originalValue: tooltipTitle,
            newValue: newTitle
          });
        }
      });
    },
    
    // 修复 iframe 内容中的空 data-tooltip-title 属性
    fixEmptyTooltipTitlesInIframe() {
      if (!this.iframeContent) return;
      
      // 创建一个临时容器来解析 iframe 内容
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = this.iframeContent;
      
      // 查找所有具有 data-tooltip-title 属性的元素
      const elementsWithTooltip = tempDiv.querySelectorAll('[data-tooltip-title]');
      
      let hasChanges = false;
      elementsWithTooltip.forEach(el => {
        const tooltipTitle = el.getAttribute('data-tooltip-title');
        
        // 如果 data-tooltip-title 为空或只有空白字符
        if (!tooltipTitle || tooltipTitle.trim() === '') {
          // 尝试从其他属性获取标题
          const alt = el.getAttribute('alt');
          const title = el.getAttribute('title');
          const ariaLabel = el.getAttribute('aria-label');
          
          // 设置一个默认的 tooltip 标题
          const newTitle = alt || title || ariaLabel || '点击查看详情';
          el.setAttribute('data-tooltip-title', newTitle);
          hasChanges = true;
          
          console.log('修复 iframe 内容中空的 data-tooltip-title:', {
            element: el,
            originalValue: tooltipTitle,
            newValue: newTitle
          });
        }
      });
      
      // 如果有修改，更新 iframeContent
      if (hasChanges) {
        this.iframeContent = tempDiv.innerHTML;
        console.log('已更新 iframe 内容，修复了空的 data-tooltip-title 属性');
      }
    },
  },
};
</script>
<style scoped>

  .articleLog {
    display: flex;
    flex-direction: column;
    height: 100vh; /* 占满整个视口高度 */
    overflow: hidden; /* 防止整体滚动 */
  }
  
  
  .articleContent{
    flex: 1; /* 占据剩余空间 */
    overflow-y: auto; /* 内容可滚动 */
  
    padding-bottom: 24px;
    /* 隐藏滚动条 */
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */
    /* 确保内容在面包屑下方正确显示 */
    position: relative;
  }
  
  /* 隐藏 Webkit 浏览器的滚动条 */
  .articleContent::-webkit-scrollbar {
    display: none;
  }
.editor {
  z-index: -1;
  border: none;
  padding: 0;
}
.editor::v-deep .v-show-content {
  padding: 0;
}
.displayNone {
  display: none;
}
.navigation-content {
  display: none;
}
.anchorBox {
  width: 20vw;

  padding-left: 2rem;
  position: fixed;
}
.anchorBox::v-deep .ant-anchor-link-active {
  border-left: 2px solid var(--theme-color);
}
.anchorBox::v-deep .ant-anchor-wrapper {
  height: 70vh;
  overflow-y: auto;
}
.sharebox {
  text-align: center;
  padding: 1rem;
  border-top: 1px solid var(--theme-light);
  border-bottom: 1px solid var(--theme-light);
}

.Titlebox {
  padding: 0 1rem;
  /* overflow: auto; */
}
.Titlebox h1 {
  font-size: 2rem;
  font-weight: 500;
}
.Titlebox p {
  padding-bottom: 0.5rem;
  /* border-bottom: 1px solid #eaf1ff; */
}
.justifyC {
  justify-content: center;
}
.mdview::v-deep .github-markdown-body {
  padding: 0px;
}

.ant-anchor-wrapper::-webkit-scrollbar {
  width: 5px;
}
.ant-anchor-wrapper::-webkit-scrollbar-track {
  background: var(--gray-4);
  border-radius: 5px;
}
.ant-anchor-wrapper::-webkit-scrollbar-thumb {
  background: var(--gray-6);
  border-radius: 5px;
}
.ant-anchor-wrapper::-webkit-scrollbar-thumb:hover {
  background: var(--gray-6);
  border-radius: 5px;
}
.anchorBox::-webkit-scrollbar-thumb:active {
  background: var(--gray-8);
  border-radius: 5px;
}
.breadcrumb-content {
  display: flex;
  align-items: center;
  width: 100%;
  padding-bottom: 8px;
}

.back-button {
  cursor: pointer;
  margin-right: 16px;
  padding: 8px;
  border-radius: 50%;
  transition: background-color 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.back-button:hover {
  background-color: var(--onFill-opacity4);
}

.back-button i {
  font-size: 18px;
  color: var(--text-secondary2);
}

.articleTitle{
  font-size: 16px;
  font-weight: 500;
  color: var(--text-primary);
  flex: 1;
}

/* 移除侧边栏样式 */

/* 全局禁用所有放大效果 */
.articleContent *,
.articleContent *:hover,
.articleContent *:focus {
  transform: none !important;
  transition: none !important;
}

/* 只保留必要的过渡效果 */
.articleContent {
  transition: none !important;
}

/* 确保图片和视频没有任何悬停效果 */
.articleContent img:hover,
.articleContent video:hover,
.mdview img:hover,
.mdview video:hover {
  transform: none !important;
  box-shadow: none !important;
  transition: none !important;
}

/* 更强力的禁用所有变换效果 */
* {
  transform: none !important;
}

*:hover {
  transform: none !important;
  box-shadow: none !important;
  transition: none !important;
}

/* 特别针对图片和视频 */
img, video {
  transform: none !important;
  transition: none !important;
}

img:hover, video:hover {
  transform: none !important;
  box-shadow: none !important;
  transition: none !important;
}

/* 移除所有侧边栏相关样式 */

/* 在iframe中禁用viewer组件的所有弹框效果 */
.viewer-container,
.viewer-backdrop,
.viewer-fixed,
.viewer-fade,
.viewer-transition,
.viewer-in {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
  pointer-events: none !important;
}

/* 禁用任何可能的viewer相关样式 */
[class*="viewer-"] {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
  pointer-events: none !important;
}

/* 禁用viewer的图片点击事件 */
.articleContent img {
  pointer-events: auto !important;
}

/* 确保viewer不会干扰我们的点击事件 */
.articleContent .viewer-container {
  display: none !important;
}

/* 为图片和视频添加点击提示 - 完全移除所有效果 */
.mdview::v-deep img,
.mdview::v-deep video {
  cursor: pointer;
}

/* 确保没有任何悬停效果 */
.mdview::v-deep img:hover,
.mdview::v-deep video:hover {
  transform: none !important;
  box-shadow: none !important;
  transition: none !important;
}
.articleContent-nodata{
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height:90vh;
  flex-direction: column;
  
}

.return-btn {
  margin-right: 3px;
  padding: 4px 6px;
  border-radius: 6px;
  cursor: pointer;
  &:hover {
    background-color: var(--onFill-opacity4);
      }
}
</style>
